import { useState, useEffect } from 'react';
import { cloneDeep, orderBy } from 'lodash';

/**
 * Custom hook to manage crop season data grouping and filtering
 */
const useCropSeasonData = (getData, debouncedSearchTerm, menuOpened) => {
  const [items, setItems] = useState({ active: [], upcoming: [], past: [] });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!menuOpened) {
      return;
    }

    // Group seasons by their status (active, upcoming, past)
    const groupSeasonsByStatus = data => {
      const currentTime = new Date().getTime();
      const groupedSeasons = { active: [], upcoming: [], past: [] };

      data.forEach(item => {
        if (currentTime > item.startDateEpoch) {
          if (currentTime > item.endDateEpoch) {
            groupedSeasons.past.push(item);
          } else {
            groupedSeasons.active.push(item);
          }
        } else {
          groupedSeasons.upcoming.push(item);
        }
      });

      // Sort past seasons alphabetically
      const pastClone = cloneDeep(groupedSeasons.past);
      const orderedPast = orderBy(
        pastClone,
        [past => past.name.toLowerCase()],
        'asc'
      );
      groupedSeasons.past = orderedPast;

      // Sort upcoming seasons alphabetically
      const upcomingClone = cloneDeep(groupedSeasons.upcoming);
      const orderedUpcoming = orderBy(
        upcomingClone,
        [upcoming => upcoming.name.toLowerCase()],
        'asc'
      );
      groupedSeasons.upcoming = orderedUpcoming;

      return groupedSeasons;
    };

    // Filter seasons based on search term
    const filterSeasons = data => {
      if (!debouncedSearchTerm) {
        return data;
      }
      return data.filter(obj =>
        obj.name.toLowerCase().includes(debouncedSearchTerm.toLowerCase())
      );
    };

    setIsLoading(true);
    const data = getData();
    const filteredData = filterSeasons(data);
    const groupedSeasons = groupSeasonsByStatus(filteredData);

    setItems(groupedSeasons);
    setIsLoading(false);
  }, [debouncedSearchTerm, menuOpened, getData]);

  return {
    items,
    isLoading
  };
};

export default useCropSeasonData;
